import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_23nx3nnsvm: FaireBrandEntity = {
  token: "b_23nx3nnsvm",
  type: "brand",
  name: "Pacific Trading",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee6003f854bd2ddee7e3743fc152b1af945693dd6f8808fd6c09c08a83961a11.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0ff69ebd71728589c908b11bdcae19e6708bc01f3a8ad18fbc41dc77639f69a0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ee6003f854bd2ddee7e3743fc152b1af945693dd6f8808fd6c09c08a83961a11.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0ff69ebd71728589c908b11bdcae19e6708bc01f3a8ad18fbc41dc77639f69a0.jpeg",
  location: "Arcadia, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 557,
  isTopShop: true,
  isInsider: true,
  description:
    "For over four decades, Pacific Trading has been a trusted name in the giftware industry, offering a diverse selection of tabletop accessories, home décor, and collectibles. Based in Edmond, Oklahoma, we have steadily expanded our product lines, crafting distinctive pieces from a variety of materials to cater to retailers and collectors alike.\n\nAt Pacific Trading, we are committed to excellence in design, innovation, and craftsmanship, bringing curated collections that inspire and elevate any space.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.340Z",
    importedBy: "entity-db-cli",
  },
};
